export function poiDetailsToWaypointDescriptionHelper(poi) {
  let stringToReturn = "";
  Object.entries(poi).forEach(([key, value]) => {
    if (value && key) {
      stringToReturn += `${key}: ${value}\n`;
    }
  })
  return stringToReturn;
}
